import {newVehicleApi, type TrimResponseBody} from '@dms/api/new-vehicle';

import {trimPublicationChanges} from '../utils/trimPublicationChanges';

/**
 * Reads what a trim status switch puts into the dealer price list or takes out of it: the matrix
 * Variants and engines, the trim's feature assignments and the colours and packages as the server
 * holds them, with the names of the library items.
 */
export function useTrimPublicationChanges() {
  const [readMatrix] = newVehicleApi.useLazyGetVariantMatrixQuery();
  const [readAssignments] = newVehicleApi.useLazyListTrimFeatureAssignmentsQuery();
  const [readFeatures] = newVehicleApi.useLazyListFeatureQuery();
  const [readColours] = newVehicleApi.useLazyListColourQuery();
  const [readPackages] = newVehicleApi.useLazyListPackageQuery();

  return async (
    trim: Pick<TrimResponseBody, 'id' | 'name' | 'modelYearId' | 'basePriceNet'>,
    direction: 'publish' | 'unpublish'
  ) => {
    const [matrix, assignments, features, colours, packages] = await Promise.all([
      readMatrix({modelYearId: trim.modelYearId}, false).unwrap(),
      readAssignments({trimId: trim.id}, false).unwrap(),
      readFeatures({}, true).unwrap(),
      readColours({}, false).unwrap(),
      readPackages({}, false).unwrap(),
    ]);
    return trimPublicationChanges({
      trim,
      direction,
      variants: matrix.cells,
      engines: matrix.engines,
      assignments,
      features: features.items,
      colours: colours.items,
      packages: packages.items,
    });
  };
}
